// TibberPrice/TibberPriceCache.js
// Plain Map<slotEms, price> per price type. Slots are keyed on the BE `ems` (UTC slot start).
import CoreBase from '../../../services/engines/CoreBase';
import { TIBBER_TYPE } from './tibberConst';

const _name = 'TibberPriceCache';

class TibberPriceCache extends CoreBase {
    _name = _name;

    _prices = { [TIBBER_TYPE.QUARTER]: new Map(), [TIBBER_TYPE.HOUR]: new Map() };

    /**
     * @param {string} type - 'quarter' or 'hour'
     * @param {{ems:number,total:number,energy:number,tax:number,level:string}[]} items
     */
    setPrices = (type, items) => {
        const map = this._prices[type];
        if (!map) return;

        items.forEach(({ ems, total, energy, tax, level }) => map.set(ems, { ems, total, energy, tax, level }));
    };

    /**
     * @param {string} type
     * @param {number} slotEms - slot start, already aligned
     * @returns {object|null}
     */
    getPrice = (type, slotEms) => this._prices[type]?.get(slotEms) ?? null;

    /**
     * @param {string} type
     * @param {number} dayEms - start of the UTC day
     * @returns {boolean} true when the first slot of that day is cached
     */
    hasDay = (type, dayEms) => this._prices[type]?.has(dayEms) ?? false;

    /**
     * @param {string} type
     * @returns {object[]} all cached slots, oldest first
     */
    getAll = (type) => [...(this._prices[type]?.values() ?? [])].sort((a, b) => a.ems - b.ems);

    clear = () => {
        Object.values(this._prices).forEach((map) => map.clear());
    };
}

const tibberPriceCache = new TibberPriceCache();
export default tibberPriceCache;
